import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import axios from 'src/utils/axios';
import { Container, Stack, Card, CardHeader, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Chip } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DetailsOfExchangeReceipt from 'src/components/DetailsOfExchangeReceipt';

const styles = {
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
};

function ReceiptDetail(props) {
    const navigate = useNavigate();

    // const { ReceiptNumber } = useParams();

    const params = useParams();
    const ReceiptNumber = params?.ReceiptNumber || props.ReceiptNumber;

    const [serviceReceiptData, setServiceReceiptData] = React.useState([]);
    const [customerData, setCustomerData] = React.useState([]);
    const [laborCodesData, setLaborCodesData] = React.useState([]);
    const [totalCostOfLaborCodes, setTotalCostOfLaborCodes] = React.useState([]);
    const [totalCostOfMaterialCodes, setTotalCostOfMaterialCodes] = React.useState([]);
    const [materialCodesData, setMaterialCodesData] = React.useState([]);
    const [serviceCodesData, setServiceCodesData] = React.useState([]);

    const KDV = 1.18;

    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getServiceReceiptData();
        getReceiptCustomerData();
        getReceiptServicesCodesData();
        getReceiptLaborCodesInformation();
        getReceiptMaterialCodesInformation();
    }, [])

    const handleGoBack = () => {
        const fullPath = location.pathname;
        var basePath = fullPath.substring(0, fullPath.lastIndexOf('/'));
        localStorage.setItem('previousPath', basePath || '/');
        navigate(-1);
    };

    const getServiceReceiptData = () => {
        axios.get(`GetServiceReceiptInformation/${ReceiptNumber}`)
            .then((response) => {
                var serviceReceiptData = response.data[0];
                setServiceReceiptData(serviceReceiptData ? serviceReceiptData : []);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptCustomerData = () => {
        axios.get(`GetReceiptCustomerData/${ReceiptNumber}`)
            .then((response) => {
                var customerData = response.data[0];
                setCustomerData(customerData ? customerData : []);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptServicesCodesData = () => {
        axios.get(`GetReceiptServiceCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var serviceCodesData = response.data;
                setServiceCodesData(Array.isArray(serviceCodesData) ? serviceCodesData : []);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptLaborCodesInformation = () => {
        axios.get(`GetReceiptLaborCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var laborCodes = response.data;
                const totalCost = laborCodes.reduce((acc, laborCode) => acc + parseFloat((laborCode.FIYAT.toFixed(2)) * KDV), 0);
                setLaborCodesData(laborCodes);
                setTotalCostOfLaborCodes(totalCost);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptMaterialCodesInformation = () => {
        axios.get(`GetReceiptMaterialCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var materialCodes = response.data;
                let totalCost = materialCodes.reduce((acc, materialCode) => {
                    const malzemefiyat = parseFloat(materialCode.MALZEMEFIYAT.toFixed(2));
                    const miktar = parseFloat(materialCode.MIKTAR);
                    return acc + (malzemefiyat * miktar);
                }, 0);
                setMaterialCodesData(materialCodes);
                setTotalCostOfMaterialCodes(totalCost);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const RouteReceiptStatusHistory = (ReceiptNumber) => {
        navigate(`/ReceiptStatusHistory/${ReceiptNumber}`);
    }

    const RouteReceiptCustomerPage = (PhoneNumber) => {
        navigate(`/ReceiptCustomer/${PhoneNumber}`);
    }

    const RouteReceiptSerialNumberPage = (UYear, UPeriod, ModelCode, SerialNo) => {
        navigate(`/IndividualInquiryReceipts/${UYear}/${UPeriod}/${ModelCode}/${SerialNo}`);
    }

    return (
        <Container maxWidth="lg" sx={{ py: 3 }}>
            <Stack spacing={3}>
                <Card>
                    <CardHeader
                        avatar={
                            <IconButton onClick={() => { handleGoBack(); }} size="small">
                                <ArrowBackIcon />
                            </IconButton>
                        }
                        title="Servis Hizmet Fişi"
                    />
                    <Divider />
                    <TableContainer>
                        <Table size='small'>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(11)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(8)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Birim:</TableCell>
                                            <TableCell colSpan={3} sx={styles.tableRow}>{serviceReceiptData.BIRIM_KODU ? (serviceReceiptData.BIRIM_KODU + '-' + serviceReceiptData.BIRIM_ACIKLAMA) : '-'}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Fiş No:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.FIS_NO}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Durum:</TableCell>
                                            <TableCell
                                                sx={styles.tableRow}
                                            >
                                                {serviceReceiptData.DURUM_ACIKLAMA ? (
                                                    <Chip
                                                        label={serviceReceiptData.DURUM_ACIKLAMA}
                                                        size="small"
                                                        variant="outlined"
                                                        clickable
                                                        onClick={() => { RouteReceiptStatusHistory(serviceReceiptData.FIS_NO); }}
                                                    />
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Müşteri:</TableCell>
                                            <TableCell sx={styles.tableRow}>{customerData.ADI}</TableCell>
                                            <TableCell colSpan={2} sx={styles.tableRow}>{customerData.SOYADI}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Dönem:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.YIL}/{serviceReceiptData.DONEM}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Malzeme:</TableCell>
                                            <TableCell sx={styles.tableRow}>{(serviceReceiptData.MALZEME_TOPLAMI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Adres:</TableCell>
                                            <TableCell colSpan={3} sx={styles.tableRow}>{customerData.ADRES}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Başvuru Nedeni:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.BASVURU_NEDENI}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>İşçilik:</TableCell>
                                            <TableCell sx={styles.tableRow}>{(serviceReceiptData.ISCILIK_TOPLAMI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>İlçe:</TableCell>
                                            <TableCell sx={styles.tableRow}>{customerData.ILCE}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Şehir:</TableCell>
                                            <TableCell sx={styles.tableRow}>{customerData.IL}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Çağrı Tarihi:</TableCell>
                                            <TableCell sx={styles.tableRow}>{moment(serviceReceiptData.CAGRI_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>İndirim:</TableCell>
                                            <TableCell sx={styles.tableRow}>{(serviceReceiptData.INDIRIM_TUTARI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Tel1:</TableCell>
                                            <TableCell
                                                sx={styles.tableRow}
                                            >
                                                {customerData.TEL1 ? (
                                                    <Chip
                                                        label={customerData.TEL1}
                                                        size="small"
                                                        variant="outlined"
                                                        clickable
                                                        onClick={() => { RouteReceiptCustomerPage(customerData.TEL1); }}
                                                    />
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Tel2:</TableCell>
                                            <TableCell
                                                sx={styles.tableRow}
                                            >
                                                {customerData.TEL2 ? (
                                                    <Chip
                                                        label={customerData.TEL2}
                                                        size="small"
                                                        variant="outlined"
                                                        clickable
                                                        onClick={() => { RouteReceiptCustomerPage(customerData.TEL2); }}
                                                    />
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Yan Ödeme:</TableCell>
                                            <TableCell sx={styles.tableRow}>{(serviceReceiptData.INDIRIM_TUTARI * KDV)?.toFixed(2)}</TableCell>
                                            <TableCell colSpan={2} sx={styles.tableHead}></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Model:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.KUL_MODEL_KODU}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Model Açıklama:</TableCell>
                                            <TableCell colSpan={3} sx={styles.tableRow}>{serviceReceiptData.MODEL_ACIKLAMA}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Net:</TableCell>
                                            <TableCell sx={styles.tableRow}>{(serviceReceiptData.NET_TUTAR * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Ürün:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.KUL_MODEL_KODU}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Ürün Açıklama:</TableCell>
                                            <TableCell colSpan={3} sx={styles.tableRow}>{serviceReceiptData.MODEL_ACIKLAMA}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Garanti Tipi:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.GARANTI_ACIKLAMA}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Ay/Yıl:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.HARF_KODU + '(' + (serviceReceiptData.UYIL + ' / ' + serviceReceiptData.UDONEM + ')')}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Seri No:</TableCell>
                                            <TableCell
                                                sx={styles.tableRow}
                                            >
                                                {serviceReceiptData.SERINO && serviceReceiptData.SERINO > 1 ? (
                                                    <Chip
                                                        label={serviceReceiptData.SERINO}
                                                        size="small"
                                                        variant="outlined"
                                                        clickable
                                                        onClick={() => {
                                                            RouteReceiptSerialNumberPage(serviceReceiptData.UYIL, serviceReceiptData.UDONEM, serviceReceiptData.MODEL_KODU, serviceReceiptData.SERINO);
                                                        }}
                                                    />
                                                ) : (
                                                    serviceReceiptData.SERINO ? serviceReceiptData.SERINO : '-'
                                                )}
                                            </TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Marka:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.MARKA_ACIKLAMA}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Başvuru No:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.BASVURU_NO}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Red Nedeni:</TableCell>
                                            <TableCell colSpan={3} sx={styles.tableRow}>{serviceReceiptData.RED_NEDENI ? serviceReceiptData.RED_NEDENI : '-'}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Nitelik:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.NITELIK_ACIKLAMA}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Bayi Kodu:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.BAYI_KODU !== '0' ? (serviceReceiptData.BAYI_KODU + '-' + serviceReceiptData.BAYIADI) : '-'}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>İşlem Tarihi:</TableCell>
                                            <TableCell sx={styles.tableRow}>{moment(serviceReceiptData.ISLEM_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Garanti Tarihi:</TableCell>
                                            <TableCell sx={styles.tableRow}>{moment(serviceReceiptData.GARANTI_TARIHI).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Muh.Tarihi:</TableCell>
                                            <TableCell sx={styles.tableRow}>{moment(serviceReceiptData.MUHASEBELESME_TARIHI).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell colSpan={2} sx={styles.tableHead}></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Teknisyen Kodu:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.KUL_TEK_KODU}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Tek. Adı Soyadı:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.ADI} {serviceReceiptData.SOYADI}</TableCell>
                                            <TableCell sx={styles.tableHead} style={{ fontWeight: 'bold' }}>Ek Garanti Sertifika No:</TableCell>
                                            <TableCell sx={styles.tableRow}>{serviceReceiptData.EKGAR_SERTIFIKA_NO}</TableCell>
                                            <TableCell colSpan={2} sx={styles.tableHead}></TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <Card>
                    <CardHeader title="Başvuru" />
                    <Divider />
                    <TableContainer>
                        <Table size='small'>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(1)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(2)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={300} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell sx={styles.tableHead} width={100} style={{ fontWeight: 'bold' }}>{'Notlar:'}</TableCell>
                                        <TableCell sx={styles.tableRow}>{serviceReceiptData.NOTLAR ? serviceReceiptData.NOTLAR : '-'}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <DetailsOfExchangeReceipt ReceiptNumber={ReceiptNumber} />

                <Card>
                    <CardHeader title="Hizmet" />
                    <Divider />
                    <TableContainer>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='right' sx={{ fontWeight: 700 }}>Hizmet</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Tanımı</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(2)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={750} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    serviceCodesData.length > 0 && serviceCodesData.map((service, index) => (
                                        <TableRow key={index}>
                                            <TableCell width={750} align='right'>{service.KUL_HIZMET_KODU}</TableCell>
                                            <TableCell width={750} align='left'>{service.ACIKLAMA}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <Card>
                    <CardHeader title="İşçilik" />
                    <Divider />
                    <TableContainer>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='right' sx={{ fontWeight: 700 }}>İşçilik Kodu</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Tanımı</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Fiyat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(3)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={750} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        {laborCodesData.length > 0 && laborCodesData.map((laborCodes, index) => (
                                            <TableRow key={index}>
                                                <TableCell align='right'>{laborCodes.KUL_ISCILIK_KODU}</TableCell>
                                                <TableCell align='left'>{laborCodes.ISCILIK_ACIKLAMA}</TableCell>
                                                <TableCell align='left'>{(laborCodes.FIYAT * KDV).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell colSpan={1}></TableCell>
                                            <TableCell align='right' sx={{ fontWeight: 700 }}>İşçilik Toplamı:</TableCell>
                                            <TableCell align='left'>{totalCostOfLaborCodes > 0 ? totalCostOfLaborCodes?.toFixed(2) : 0}</TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <Card>
                    <CardHeader title="Malzeme" />
                    <Divider />
                    <TableContainer>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='right' sx={{ fontWeight: 700 }}>Malzeme Kodu</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Tanımı</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Miktar</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 700 }}>Fiyat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(4)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={750} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        {materialCodesData.length > 0 && materialCodesData.map((materialCodes, index) => (
                                            <TableRow key={index}>
                                                <TableCell align='right'>{materialCodes.MALZEME_STOK_NO}</TableCell>
                                                <TableCell align='left'>{materialCodes.ACIKLAMA}</TableCell>
                                                <TableCell align='left'>{materialCodes.MIKTAR}</TableCell>
                                                <TableCell align='left'>{(materialCodes.MALZEMEFIYAT).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell colSpan={3} align='right' sx={{ fontWeight: 700 }}>Malzeme Toplamı:</TableCell>
                                            <TableCell align='left'>{totalCostOfMaterialCodes > 0 ? totalCostOfMaterialCodes?.toFixed(2) : 0}</TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Stack>
        </Container>
    );
}

export default ReceiptDetail;
